// extracted by mini-css-extract-plugin
module.exports = {"list":"ThirdPartiesList-module__list___TkGrR","empty":"ThirdPartiesList-module__empty___3Hrpb"};